export default __webpack_public_path__ + "static/media/special-events-desktop@2x.80e8e095.jpg";